import * as React from "react";
import { useEffect, useState } from "react";
import Panel from "../core/Panel";
import { assignCourseToUser, getAllCourses } from "../../libs/courses";
import styled from "styled-components";
import { getOrgUsers } from "../../libs/organization";
import Loader from "../core/Loader";
import { toast } from "../../utils";
import useSet from "../hooks/useSet";
import { getUsers } from "../../libs/user";
import Gravatar from "../core/Gravatar";
import Button from "../core/Button";
import OrgPicker from "../core/OrgPicker";
import usePromise from "../hooks/usePromise";
import FilterInput from "../core/FilterInput";

const CourseDiv = styled.div<{ selected: boolean }>`
  cursor: pointer;
  border-radius: 2px;
  padding: 5px;
  color: ${props => (props.selected ? "white" : "inherit")};
`;

const UserDiv = styled.div<{}>``;

interface IProps {
  userContext: IUserContextNormalized;
  selectedOrgId: string;
  setSelectedOrgId: (orgId: string) => void;
}

function AssignCourses({
  userContext,
  selectedOrgId,
  setSelectedOrgId,
}: IProps) {
  const [availableCourses, { loading: loadingCourses }] = usePromise(() =>
    getAllCourses()
  );

  const [selectedCourseId, setSelectedCourseId] = useState<null | string>(null);

  const [
    availableUsers,
    { loading: loadingUsers, reload: reloadUsers },
  ] = usePromise(
    () => {
      let users:any;
      // console.log('user', userContext.user)
      if(userContext.user.isAdmin){
        users =  getOrgUsers(selectedOrgId)
      }
      else if(userContext.user.isManager && !userContext.user.isAdmin){
        users =  getUsers(userContext.user.subordinates.map(s => s.id))
      }
      else{
        users =  getOrgUsers(selectedOrgId)
      }
      return users
    },
    [selectedOrgId]
  );

  const [userFilter, setUserFilter] = useState("");

  const filteredUsers = userFilter
    ? availableUsers.filter(user =>
        user.name.toUpperCase().includes(userFilter.toUpperCase())
      )
    : availableUsers;

  const lockedUsers = useSet();

  const selectedCourse = (availableCourses || []).find(
    c => selectedCourseId === c.id
  );

  const canChangeOrg = userContext.user.isAdmin;

  async function assign(userId) {
    if (!selectedCourseId) {
      return;
    }
    lockedUsers.add(userId);
    const resp = await assignCourseToUser(selectedCourseId, userId);
    await reloadUsers();
    lockedUsers.delete(userId);
    toast.success("Course assigned!");
  }

  const loading = loadingCourses || loadingUsers;

  return (
    <>
      {canChangeOrg && (
        <>
          <label>Selected Org</label>
          <OrgPicker
            selectedOrgId={selectedOrgId}
            setSelectedOrgId={setSelectedOrgId}
            userContext={userContext}
          />
          <hr />
        </>
      )}
      {loading ? (
        <Loader />
      ) : (
        <div className="columns">
          <div className="column">
            <Panel heading={"Choose a Course"}>
              {availableCourses.map(course => (
                <CourseDiv
                  selected={selectedCourseId === course.id}
                  className={selectedCourseId === course.id ? "bg-info" : ""}
                  key={course.id}
                  onClick={() => setSelectedCourseId(course.id)}
                >
                  {course.title}
                </CourseDiv>
              ))}
            </Panel>
          </div>
          <div className="column">
            <Panel heading={"Assign to Users"}>
              {selectedCourseId ? (
                <>
                  <FilterInput
                    placeholder={"Filter users"}
                    value={userFilter}
                    onChange={setUserFilter}
                  />
                  <p>&nbsp;</p>
                  {filteredUsers.map(user => (
                    <AssignableUser
                      key={user.id}
                      user={user}
                      isAssigned={
                        selectedCourseId &&
                        user.courses.map(a => a.id).includes(selectedCourseId)
                      }
                      isLocked={lockedUsers.has(user.id)}
                      assignUser={() => assign(user.id)}
                      courseName={selectedCourse!.title}
                    />
                  ))}
                </>
              ) : (
                <p>Select a course first.</p>
              )}
            </Panel>
          </div>
        </div>
      )}
    </>
  );
}

export default AssignCourses;

function AssignableUser({
  user,
  isAssigned,
  assignUser,
  isLocked,
  courseName,
}) {
  return (
    <UserDiv>
      <Panel>
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <Gravatar email={user.email} size={"30"} edit={false} />
            </div>
            <div className="level-item">
              <p>{user.name}</p>
            </div>
          </div>
          <div className="level-right" />
        </div>
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <Button
                className="btn btn-info"
                onClick={assignUser}
                disabled={isAssigned || isLocked}
                loading={isLocked}
              >
                {isAssigned ? (
                  <span>
                    <i className="fa fa-check" /> Assigned to {courseName}
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-plus" /> Assign to {courseName}
                  </span>
                )}
              </Button>
            </div>
          </div>
        </div>
      </Panel>
    </UserDiv>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/courses/AssignCourses.tsx